import { useMediaQuery } from 'react-responsive';

export const isPortrait = () =>
  useMediaQuery({
    orientation: 'portrait',
  });
